/**
 * Мелкие настройки, которые живут в localStorage и переживают перезагрузку.
 * localStorage может быть недоступен (приватный режим) — все обращения тихие.
 */

export const HEADPHONES_ACK_KEY = 'ozvuchka.headphonesAck'

export function readPref(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export function writePref(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    // приватный режим — настройка просто не переживёт перезагрузку
  }
}

/**
 * Пользователь подтвердил, что он в наушниках (docs/RECORDING.md, «Захват
 * микрофона»). Без них оригинальная дорожка попадёт в дубль.
 */
export function headphonesAcknowledged(): boolean {
  return readPref(HEADPHONES_ACK_KEY) === '1'
}

export function acknowledgeHeadphones(): void {
  writePref(HEADPHONES_ACK_KEY, '1')
}
